import { c as _c } from "react-compiler-runtime";
import { useEffect, useMemo } from 'react';
import { useStateValue } from '../../../store/collaborationSidebarProvider';
export function useEmbeddedCommentPopover(t0) {
  "use memo";

  const $ = _c(19);
  const {
    iframeContainerID,
    popoverContentWrapperRef,
    closeEmbeddedCommentPopover
  } = t0;
  const commentableAreaClickCoordinates = useStateValue("commentableAreaClickCoordinates");
  const isEmbeddedPopoverOpen = useStateValue("isEmbeddedPopoverOpen");
  const embeddedCommentCoordinates = useStateValue("embeddedCommentCoordinates");
  const embeddedPopoverAnchorSelector = useStateValue("embeddedPopoverAnchorSelector");
  let t1;
  let t2;
  if ($[0] !== embeddedPopoverAnchorSelector || $[1] !== iframeContainerID) {
    var _referenceElement;
    let referenceElement;
    if (embeddedPopoverAnchorSelector) {
      referenceElement = document.querySelector(embeddedPopoverAnchorSelector);
    } else {
      if (iframeContainerID) {
        referenceElement = document.getElementById(iframeContainerID);
      }
    }
    t2 = (_referenceElement = referenceElement) === null || _referenceElement === void 0 ? void 0 : _referenceElement.getBoundingClientRect();
    $[0] = embeddedPopoverAnchorSelector;
    $[1] = iframeContainerID;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const referenceRect = t2;
  if (isEmbeddedPopoverOpen) {
    const t3 = referenceRect ? embeddedCommentCoordinates.top + referenceRect.top : embeddedCommentCoordinates.top;
    const t4 = referenceRect ? embeddedCommentCoordinates.left + referenceRect.left : embeddedCommentCoordinates.left;
    let t5;
    if ($[3] !== embeddedCommentCoordinates.height || $[4] !== embeddedCommentCoordinates.width || $[5] !== t3 || $[6] !== t4) {
      t5 = {
        top: t3,
        left: t4,
        width: embeddedCommentCoordinates.width,
        height: embeddedCommentCoordinates.height
      };
      $[3] = embeddedCommentCoordinates.height;
      $[4] = embeddedCommentCoordinates.width;
      $[5] = t3;
      $[6] = t4;
      $[7] = t5;
    } else {
      t5 = $[7];
    }
    t1 = t5;
  } else {
    let t3;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = {
        top: 0,
        left: 0,
        width: 0,
        height: 0
      };
      $[8] = t3;
    } else {
      t3 = $[8];
    }
    t1 = t3;
  }
  const dimensionsAndCoordinates = t1;
  let t3;
  let t4;
  if ($[9] !== closeEmbeddedCommentPopover || $[10] !== commentableAreaClickCoordinates || $[11] !== embeddedPopoverAnchorSelector || $[12] !== iframeContainerID || $[13] !== isEmbeddedPopoverOpen || $[14] !== popoverContentWrapperRef) {
    t3 = () => {
      var _popoverContentWrappe, _referenceElement_;
      if (!isEmbeddedPopoverOpen || !commentableAreaClickCoordinates) {
        return;
      }
      const popoverRect = (_popoverContentWrappe = popoverContentWrapperRef.current) === null || _popoverContentWrappe === void 0 ? void 0 : _popoverContentWrappe.getBoundingClientRect();
      let referenceElement_0;
      if (embeddedPopoverAnchorSelector) {
        referenceElement_0 = document.querySelector(embeddedPopoverAnchorSelector);
      } else {
        if (iframeContainerID) {
          referenceElement_0 = document.getElementById(iframeContainerID);
        }
      }
      const referenceRect_0 = (_referenceElement_ = referenceElement_0) === null || _referenceElement_ === void 0 ? void 0 : _referenceElement_.getBoundingClientRect();
      const absoulteCoordinates = {
        x: commentableAreaClickCoordinates.x + ((referenceRect_0 === null || referenceRect_0 === void 0 ? void 0 : referenceRect_0.left) || 0),
        y: commentableAreaClickCoordinates.y + ((referenceRect_0 === null || referenceRect_0 === void 0 ? void 0 : referenceRect_0.top) || 0)
      };
      if (popoverRect && commentableAreaClickCoordinates) {
        if (absoulteCoordinates.x < popoverRect.left || absoulteCoordinates.x > popoverRect.right || absoulteCoordinates.y < popoverRect.top || absoulteCoordinates.y > popoverRect.bottom) {
          closeEmbeddedCommentPopover();
        }
      }
    };
    t4 = [isEmbeddedPopoverOpen, commentableAreaClickCoordinates, closeEmbeddedCommentPopover, iframeContainerID, popoverContentWrapperRef, embeddedPopoverAnchorSelector];
    $[9] = closeEmbeddedCommentPopover;
    $[10] = commentableAreaClickCoordinates;
    $[11] = embeddedPopoverAnchorSelector;
    $[12] = iframeContainerID;
    $[13] = isEmbeddedPopoverOpen;
    $[14] = popoverContentWrapperRef;
    $[15] = t3;
    $[16] = t4;
  } else {
    t3 = $[15];
    t4 = $[16];
  }
  useEffect(t3, t4);
  let t5;
  if ($[17] !== dimensionsAndCoordinates) {
    t5 = {
      dimensionsAndCoordinates
    };
    $[17] = dimensionsAndCoordinates;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  return t5;
}